import { ModuleBase } from "@/modules/base";
import { Component, Mixins } from 'vue-property-decorator';
import Window from './Window.vue';
import AnalysisMenu from './AnalysisMenu.vue'

@Component
export class IframeModule extends Mixins(ModuleBase) {
  show = false

  get outlet() {
    return {
      window: Window,
      analysisMenu: AnalysisMenu,
    }
  }
}
